import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import React from 'react';

type ElementProps<T extends keyof React.JSX.IntrinsicElements> = {
    as: T;
    children?: ReactNode;
} & ComponentPropsWithoutRef<T>;

export const Element = <T extends keyof React.JSX.IntrinsicElements>({ as, children, ...props }: ElementProps<T>) => {
    return React.createElement(as, props, children);
};
